import { Context, createContext } from "solid-js"
import { Engine } from "../lib/core/engine/Engine.type"

const EngineContext : Context<Engine> = createContext<Engine>() as Context<Engine>

export default EngineContext
